import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { StoreService } from 'src/app/services/infra/store/store.service';
import { LoggerService } from 'src/app/services/infra/logger/logger.service';
import { IncidentCreatedSuccessfullyDialogComponent } from '../incident-created-successfully-dialog/incident-created-successfully-dialog.component';
import { timer } from 'rxjs';

@Component({
  selector: 'app-contact-soc-dialog',
  templateUrl: './contact-soc-dialog.component.html',
  styleUrls: ['./contact-soc-dialog.component.scss'],
})
export class ContactSOCDialogComponent {
  public waitingForResponse = false;

  constructor(
    public dialogRef: MatDialogRef<ContactSOCDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ContactSOCDialogComponent,
    @Inject(MAT_DIALOG_DATA) public incidentDescription: string,
    private readonly _matDialog: MatDialog,
    private readonly _logger: LoggerService,
    private readonly _store: StoreService
  ) {}

  public onClose(): void {
    this.dialogRef.close();
  }

  public onCreateIncidentClick(): void {
    this.waitingForResponse = true;
    timer(1000).subscribe(() => {
      this._matDialog.open(IncidentCreatedSuccessfullyDialogComponent, {
        data: {},
        disableClose: false,
        panelClass: 'sized-popup-dialog-container',
        width: `600px`,
        height: `150px`,
      });
      this.dialogRef.close();
    });
  }
}
